// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__sortableHeader--mwC1L {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

/* Inner flex row lays out icon + label as a single adjacent group; the parent th's
   text-align controls where the whole group lands (left/center/right). */
.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__inner--SiqvU {
  display: inline-flex;
  align-items: center;
}

.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__sortableHeader--mwC1L:hover {
  background-image: linear-gradient(
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0.1)
  );
}

.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__label--uk1qo {
  vertical-align: middle;
}

.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__sortIcon--r49Ln {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  margin-right: 8px;
  vertical-align: middle;
}

.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__sortIconRight--mr7Eg {
  margin-right: 0;
  margin-left: 8px;
}

.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__triangleUp--FzeRK,
.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__triangleDown--finuL {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
}

.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__triangleUp--FzeRK {
  border-bottom: 7px solid #8a97a4;
}

.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__triangleDown--finuL {
  border-top: 7px solid #8a97a4;
}

.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__triangleUp--FzeRK.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__triangleActive--dMkJp {
  border-bottom-color: #ffffff;
}

.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__triangleDown--finuL.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__triangleActive--dMkJp {
  border-top-color: #ffffff;
}

.src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__active--O2Drf {
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/usageReportingContainer/components/sortableColumnHeader.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;yEACyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE;;;GAGC;AACH;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".sortableHeader {\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n}\n\n/* Inner flex row lays out icon + label as a single adjacent group; the parent th's\n   text-align controls where the whole group lands (left/center/right). */\n.inner {\n  display: inline-flex;\n  align-items: center;\n}\n\n.sortableHeader:hover {\n  background-image: linear-gradient(\n    rgba(255, 255, 255, 0.1),\n    rgba(255, 255, 255, 0.1)\n  );\n}\n\n.label {\n  vertical-align: middle;\n}\n\n.sortIcon {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  margin-right: 8px;\n  vertical-align: middle;\n}\n\n.sortIconRight {\n  margin-right: 0;\n  margin-left: 8px;\n}\n\n.triangleUp,\n.triangleDown {\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n}\n\n.triangleUp {\n  border-bottom: 7px solid #8a97a4;\n}\n\n.triangleDown {\n  border-top: 7px solid #8a97a4;\n}\n\n.triangleUp.triangleActive {\n  border-bottom-color: #ffffff;\n}\n\n.triangleDown.triangleActive {\n  border-top-color: #ffffff;\n}\n\n.active {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sortableHeader": `src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__sortableHeader--mwC1L`,
	"inner": `src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__inner--SiqvU`,
	"label": `src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__label--uk1qo`,
	"sortIcon": `src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__sortIcon--r49Ln`,
	"sortIconRight": `src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__sortIconRight--mr7Eg`,
	"triangleUp": `src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__triangleUp--FzeRK`,
	"triangleDown": `src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__triangleDown--finuL`,
	"triangleActive": `src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__triangleActive--dMkJp`,
	"active": `src-js-pages-usageReportingContainer-components-sortableColumnHeader-module__active--O2Drf`
};
export default ___CSS_LOADER_EXPORT___;
